// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Changes here may need to be reflected in CardFront.less */
.NYIHAreWw6Ga8y {
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.NYIHAreWw6Ga8y div[role='presentation'] {
  display: flex;
  position: relative;
}
.NYIHAreWw6Ga8y .YGgOKiGOXJp93L {
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  margin: var(--ds-space-025, 2px) var(--ds-space-075, 6px) var(--ds-space-0, 0) var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .NoOONODMSFVVz7 {
  display: flex;
  position: relative;
  z-index: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
@media (prefers-reduced-motion: no-preference) {
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .NoOONODMSFVVz7.G4M12L7sDtdO_s {
    animation: eKy7YP8TtZP2Xe 0.3s ease-in;
  }
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .NoOONODMSFVVz7 span svg {
  opacity: 1;
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .Ar0QIGe6rxuc17 span svg {
  height: 10px;
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .Ar0QIGe6rxuc17:active svg circle {
  stroke: currentColor;
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-025, 2px);
  bottom: var(--ds-space-025, 2px);
  left: var(--ds-space-0, 0);
  pointer-events: none;
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9 {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 1.5px;
  transform-origin: center;
  opacity: 0;
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(1) {
  --rotation: 0deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(2) {
  --rotation: 45deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(3) {
  --rotation: 90deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(4) {
  --rotation: 135deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(5) {
  --rotation: 180deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(6) {
  --rotation: 225deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(7) {
  --rotation: 270deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(8) {
  --rotation: 315deg;
  transform: rotate(var(--rotation)) translate(11px);
}
@media (prefers-reduced-motion: no-preference) {
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(1).xgK2dHBnpYezsH,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(3).xgK2dHBnpYezsH,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(5).xgK2dHBnpYezsH,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(7).xgK2dHBnpYezsH {
    animation: tIw4qff0u6tRY7 0.8s ease-in-out;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(1).Bze6djoVFyPmuL,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(3).Bze6djoVFyPmuL,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(5).Bze6djoVFyPmuL,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(7).Bze6djoVFyPmuL {
    animation: fanp6e3pG8Fnx_ 0.8s ease-in-out;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(2).xgK2dHBnpYezsH,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(4).xgK2dHBnpYezsH,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(6).xgK2dHBnpYezsH,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(8).xgK2dHBnpYezsH {
    animation: xMXiAjqiC26rXD 0.8s ease-in-out;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(2).Bze6djoVFyPmuL,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(4).Bze6djoVFyPmuL,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(6).Bze6djoVFyPmuL,
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .g5OCVuiQCq3B9E .QesNigSeXBZPU9:nth-child(8).Bze6djoVFyPmuL {
    animation: YIQb9hLuM2RB0o 0.8s ease-in-out;
  }
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L .gFUhCUu1hayt4r {
  bottom: var(--ds-space-negative-025, -2px);
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L.koryp4JPBeUuqE {
  transition: opacity 0.3s ease-in;
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L.koryp4JPBeUuqE {
    transition: none;
    opacity: 1;
  }
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L.koryp4JPBeUuqE:focus-visible {
  transition: opacity 0.3s ease-in;
  opacity: 1;
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L:disabled {
  cursor: pointer;
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L:active:not(:disabled) {
  transform: scale(0.9);
  transition: all 0.1s ease-in;
  opacity: 0.8;
}
@media (prefers-reduced-motion: reduce) {
  .NYIHAreWw6Ga8y .FUYvZd1AtGaY8L:active:not(:disabled) {
    transform: none;
    transition: none;
    opacity: 1;
  }
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L:hover:not(:disabled) {
  background: transparent;
}
.NYIHAreWw6Ga8y .FUYvZd1AtGaY8L:hover:not(:disabled) span svg {
  opacity: 0.9;
}
.NYIHAreWw6Ga8y .WpBdHiAP8hTeQK {
  width: 100%;
}
@media (prefers-reduced-motion: reduce) {
  .NYIHAreWw6Ga8y .WpBdHiAP8hTeQK {
    width: calc(100% - 20px);
  }
}
.NYIHAreWw6Ga8y .WpBdHiAP8hTeQK.XDHYwHPOHXAY3_ {
  width: calc(100% - 20px);
  color: var(--ds-text-subtlest, #626f86);
}
.NYIHAreWw6Ga8y .WpBdHiAP8hTeQK.XDHYwHPOHXAY3_ [data-smart-element='Title'] {
  color: var(--ds-text-subtlest, #626f86);
}
.NYIHAreWw6Ga8y .WpBdHiAP8hTeQK.wJnpzzdnnH1u6P {
  width: 100%;
  transform: translateX(-20px);
  transition: all 0.3s ease-in;
}
@media (prefers-reduced-motion: reduce) {
  .NYIHAreWw6Ga8y .WpBdHiAP8hTeQK.wJnpzzdnnH1u6P {
    width: calc(100% - 20px);
    transform: translateX(0px);
    transition: none;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .NYIHAreWw6Ga8y:hover .FUYvZd1AtGaY8L.koryp4JPBeUuqE,
  .NYIHAreWw6Ga8y:focus-within .FUYvZd1AtGaY8L.koryp4JPBeUuqE {
    transition: opacity 0.3s ease-in;
    opacity: 1;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .NYIHAreWw6Ga8y:hover .WpBdHiAP8hTeQK.wJnpzzdnnH1u6P,
  .NYIHAreWw6Ga8y:focus-within .WpBdHiAP8hTeQK.wJnpzzdnnH1u6P {
    width: calc(100% - 20px);
    transform: translateX(0px);
    transition: transform 0.3s ease-in;
  }
}
[data-smart-block]:has(.NYIHAreWw6Ga8y) {
  overflow: visible;
}
@keyframes eKy7YP8TtZP2Xe {
  0% {
    transform: rotate(-15deg);
    opacity: 0;
  }
  50% {
    transform: rotate(15deg);
    opacity: 1;
  }
  100% {
    transform: rotate(0deg);
    opacity: 1;
  }
}
@keyframes tIw4qff0u6tRY7 {
  0% {
    transform: rotate(var(--rotation)) translate(11px) scaleX(1);
    opacity: 0;
  }
  25% {
    transform: rotate(var(--rotation)) translate(12px) scaleX(2);
    opacity: 1;
  }
  75% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1.5);
    opacity: 0.5;
  }
  100% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1);
    opacity: 0;
  }
}
@keyframes xMXiAjqiC26rXD {
  0% {
    transform: rotate(var(--rotation)) translate(11px) scaleX(1);
    opacity: 0;
  }
  25% {
    transform: rotate(var(--rotation)) translate(12px) scaleX(1.5);
    opacity: 0.5;
  }
  50% {
    transform: rotate(var(--rotation)) translate(12px) scaleX(1.5);
    opacity: 1;
  }
  75% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1);
    opacity: 0.05;
  }
  100% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1);
    opacity: 0;
  }
}
@keyframes fanp6e3pG8Fnx_ {
  0% {
    transform: rotate(var(--rotation)) translate(7px) scaleX(1);
    opacity: 0;
  }
  25% {
    transform: rotate(var(--rotation)) translate(8px) scaleX(2);
    opacity: 1;
  }
  75% {
    transform: rotate(var(--rotation)) translate(8px) scaleX(1.5);
    opacity: 0.5;
  }
  100% {
    transform: rotate(var(--rotation)) translate(9px) scaleX(1);
    opacity: 0;
  }
}
@keyframes YIQb9hLuM2RB0o {
  0% {
    transform: rotate(var(--rotation)) translate(7px) scaleX(1);
    opacity: 0;
  }
  25% {
    transform: rotate(var(--rotation)) translate(8px) scaleX(1.5);
    opacity: 0.5;
  }
  50% {
    transform: rotate(var(--rotation)) translate(8px) scaleX(1.5);
    opacity: 1;
  }
  75% {
    transform: rotate(var(--rotation)) translate(9px) scaleX(1);
    opacity: 0.05;
  }
  100% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1);
    opacity: 0;
  }
}
`, ""]);
// Exports
export var cardDoneState = `NYIHAreWw6Ga8y`;
export var animationContainer = `YGgOKiGOXJp93L`;
export var checkmarkButton = `FUYvZd1AtGaY8L`;
export var iconContainer = `NoOONODMSFVVz7`;
export var buttonRotatingAnimation = `G4M12L7sDtdO_s`;
export var rotateButton = `eKy7YP8TtZP2Xe`;
export var iconContainerSmall = `Ar0QIGe6rxuc17`;
export var linesContainer = `g5OCVuiQCq3B9E`;
export var line = `QesNigSeXBZPU9`;
export var lineAnimation = `xgK2dHBnpYezsH`;
export var orthogonalLineAnimation = `tIw4qff0u6tRY7`;
export var lineAnimationSmall = `Bze6djoVFyPmuL`;
export var orthogonalLineAnimationSmall = `fanp6e3pG8Fnx_`;
export var diagonalLineAnimation = `xMXiAjqiC26rXD`;
export var diagonalLineAnimationSmall = `YIQb9hLuM2RB0o`;
export var linesContainerSmall = `gFUhCUu1hayt4r`;
export var buttonAnimation = `koryp4JPBeUuqE`;
export var cardTitle = `WpBdHiAP8hTeQK`;
export var isComplete = `XDHYwHPOHXAY3_`;
export var cardTitleAnimation = `wJnpzzdnnH1u6P`;
export default ___CSS_LOADER_EXPORT___;
